// Valid values for checkout settings
export type CartLayout = "1column" | "2column";

// Checkout settings type with all validated fields
export type CartSettings = {
  website_cart_layout: CartLayout;
};

// Helper function to validate and provide defaults
export function validateCartSettings(
  rawSettings: Partial<Record<keyof CartSettings, string>> | null
): CartSettings {
  const defaults: CartSettings = {
    website_cart_layout: "2column",
  };

  if (!rawSettings) {
    return defaults;
  }

  const validLayouts: CartLayout[] = ["1column", "2column"];

  return {
    website_cart_layout:
      rawSettings.website_cart_layout &&
      rawSettings.website_cart_layout.trim() !== "" &&
      validLayouts.includes(rawSettings.website_cart_layout as CartLayout)
        ? (rawSettings.website_cart_layout as CartLayout)
        : defaults.website_cart_layout,
  };
}
